<template>
  <div class="project-view-progress-track-list-item">
    <div class="track-name">{{ track.name }}</div>
    <div class="track-progress">
      <div class="track-progress-prog" :style="progStyle"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { ProgressTrack } from "@/store/projects";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    track: {
      type: Object,
      required: true,
    },
  },
})
export default class ProgressTrackListItem extends Vue {
  track!: ProgressTrack;

  get progStyle() {
    return {
      width: `${this.track.progress}%`,
    };
  }
}
</script>

<style lang="scss">
.project-view-progress-track-list-item {
  padding: 4px;
  margin-bottom: 4px;
  height: 46px;
  box-sizing: border-box;
  background: #f0f0f0;

  .track-name {
    font-weight: bold;
    font-size: 1.2em;
    margin-bottom: 8px;
  }

  .track-progress {
    height: 8px;
    border: 1px solid #999;
    position: relative;
    .track-progress-prog {
      background-color: #ccc;
      height: 8px;
    }
  }
}
</style>
